/* eslint-disable import/no-anonymous-default-export */
import { api, asResult } from "utils/apiClient";
import { GroupType, UserType } from "utils/constants";
import { normalizeGroup, normalizeUser } from "utils/normalize";

export default {
  // Every SP the caller may see: all of them for the NTT admin; an SP user's
  // own SP plus, for a RE-OEM-MAN parent, its child SPs. Scope comes from the
  // token.
  async listSP() {
    const { items } = await api("GET", "/groups", {
      query: { type: GroupType.ServiceProvider },
    });
    return { items: items.map(normalizeGroup) };
  },

  // The NTT admin lists both SP user types; an SP caller only has spUsers in
  // scope, and the BE leaves out what it may not read.
  async listSPUser() {
    const { items } = await api("GET", "/users", {
      query: { type: [UserType.ServiceProvider, UserType.NTTsp] },
    });
    return { items: items.map(normalizeUser) };
  },

  async createSP({ spId, spName, spType, parentID }) {
    return asResult(
      api("POST", "/groups", {
        body: {
          type: GroupType.ServiceProvider,
          groupName: spId,
          descName: spName,
          spType,
          parentID: parentID || null,
        },
      })
    );
  },

  async editSP({ spId, spName }) {
    return asResult(
      api("PATCH", `/groups/${encodeURIComponent(spId)}`, {
        body: { descName: spName },
      })
    );
  },

  async createSPUser({ email, profileName, spID, userType, role, tag }) {
    return asResult(
      api("POST", "/users", {
        body: {
          type: userType || UserType.ServiceProvider,
          username: email,
          email,
          profileName,
          role,
          spID,
          tag,
        },
      })
    );
  },
};
